<% var dateFormat = I18n.moment_date_format + ", " + I18n.moment_time_format %>
<% var dateFormatWithYear = I18n.moment_date_format_with_year + ", " + I18n.moment_time_format %>
<div class="item-icon --slot"></div>
<div class="item-content">
  <div class="appointment-slot-datestamp">
    <strong><%= Sparkle.Utilities.appointmentDate(moment.parseZone(booking.appointment_slot.start_time), AppointmentBooking.config.slot_show_year, dateFormat, dateFormatWithYear) %></strong>
  </div>
  <% if (booking.visit_type_chosen) { %>
    <div class="appointment-slot-visit-type">
      <%- booking.appointment_slot.visit_type_name %>
    </div>
  <% } else { %>
    <div class="appointment-slot-visit-type --unspecified">
      <em><%= I18n.header.visit_reason_not_chosen %></em>
    </div>
  <% } %>
</div>
